   
    
const moduleData = {
  id: "module-1",
  title: "Module 1",
  subtitle: "Obstacles in man’s journey to Divinity and their root cause",
   cardImage: "/enBanner/m1_banner.jpg",
   pdfPath: "/en/Modules/m1.pdf",
  audio: {
    title: "Vedic Chanting - Placeholder",
    audioUrl: "/en/Audio/m1.mp3",
    duration: "0:00"
  },
  video: {
    id: "g-g1_2_g_0k"
  },
  hero: {
    title: "Module 1",
    subtitle: "Obstacles in man’s journey to Divinity and their root cause",
    description: "Content for this module is coming soon.",
    buttonText: "Explore",
    bgImage: "/enBanner/m1_banner.jpg",
    bgAlt: "Placeholder"
  },
  pages: [
    {
      pageId: 'definition',
      title: 'Definition',
      definition: {
        sectionLabel: "Definition",
        title: "What are Obstacles in man’s journey to Divinity and their root cause?",
        text: "Placeholder text.",
        quote: {
          sanskrit: "",
          meaning: "",
          origin: ""
        },
        description: "Placeholder description.",
        source: "",
        image: "",
        imageAlt: ""
      }
    },
    {
      pageId: 'quiz',
      title: 'Quiz',
      quiz: {
        questions: [
          {
            question: "What is considered the root cause of all troubles, chaos, and discord in the world today?",
            options: ["Lack of education", "Attachment to the body, leading to selfishness", "Insufficient technology", "Poor governance"],
            answer: "Attachment to the body, leading to selfishness"
          },
          {
            question: "What are the three core issues that Swami abstracts as the root causes of obstacles on the spiritual path?",
            options: ["Mala, Vikshepa, Avarana", "Karma, Bhakti, Jnana", "Desire, Anger, Greed", "Ignorance, Attachment, Ego"],
            answer: "Mala, Vikshepa, Avarana"
          },
          {
            question: "According to the teachings, man has conquered himself but not the world.",
            options: ["True", "False"],
            answer: "False"
          },
          {
            question: "Education without character is NOT considered an obstacle in the spiritual journey.",
            options: ["True", "False"],
            answer: "False"
          }
        ]
      }
    },
    {
      pageId: 'feedback',
      title: 'Feedback',
      feedback: {}
    }
  ]
};

export { moduleData };
